<template>
  <div id="holacon-session-container" class="networking-session-container" v-if="currentRoom && currentEvent" :style="'background-image: url(' + currentRoom.backgroundBanner + '?width=1920&height=1200'">
    <!-- <div id="invite-step" style=" position: absolute; right: 0; z-index: 9">
      <el-button class="add-user-button" :disabled="loading" @click="addPerson = true" round>
        <i class="fas fa-user-plus"></i>
        {{ $t("invite_room") }}
      </el-button>
    </div> -->
    <Room roomType="networking" :roomId="currentRoom.id" :key="currentRoom.id" v-if="getParticipant != null && getParticipant.item != null"></Room>

    <el-dialog :visible.sync="$store.state.addPerson" :title="$t('inviteToRoom')" class="default" :close-on-click-modal="false" center append-to-body destroy-on-close>
      <div id="currentSpeaker-dialog" class="custom-modal">
        <div class="modal-body">
          <transition name="el-fade-in" mode="out-in">
            <el-row>
              <Participants :showInvite="true" @closeNetworkRequestModal="$store.state.addPerson = false" />
            </el-row>
          </transition>
        </div>
        <div class="modal-footer" slot="footer">
          <div class="left-buttons">
            <el-button @click="$store.state.addPerson = false">{{ $t("close") }}</el-button>
          </div>
          <div class="right-buttons"></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Room from "../media/Room";
import Participants from "../../modules/Participants";

export default {
  name: "Network",

  components: {
    Room,
    Participants
  },

  data() {
    return {
      loading: false,
    };
  },

  methods: {},
  async beforeMount() {
    if (this.currentRoom == null || this.currentRoom == undefined) {
      var res = await this.$store.dispatch("joinRoom", this.$route.params.network_id);
      if (res.status == 404) {
        this.$router.push({ name: "networking" });
      }
    }
    this.$socket.emit("subscribe", {
      channel: "networking-" + this.currentEvent.id,
      token: ""
    });
    this.$socket.emit("subscribe", {
      channel: "networking-area-" + this.currentEvent.id,
      token: ""
    });
    this.$socket.emit("subscribe", { channel: "presence-networking-" + this.currentApplication.id + "-" + this.currentEvent.id + "-" + this.currentRoom.id, token: "" });

    this.$socket.on("networking-" + this.currentEvent.id + "-networkingAreaRemoved", data => {
      if (data.data.Id == this.$route.params.network_id) {
        this.$router.push({ name: "networking" });
      }
    });
  },

  beforeDestroy() {
    this.$socket.emit("unsubscribe", "networking-" + this.currentEvent.id);
    this.$socket.emit("unsubscribe", "networking-area-" + this.currentEvent.id);
    if(this.currentRoom != null)
    {
       this.$socket.emit("unsubscribe", "presence-networking-" + this.currentApplication.id + "-" + this.currentEvent.id + "-" + this.currentRoom.id);
    }

    this.$store.commit("setCurrentRoom", null);
  },

  computed: {
    addPerson() {
      return this.$store.state.addPerson;
    },
    currentApplication() {
      return this.$store.getters.getApplication;
    },
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    currentRoom() {
      return this.$store.getters.getCurrentRoom;
    },
    getParticipant() {
      return this.$store.state.participant;
    }
  },
  watch: {
    currentRoom(newVal) {
      if (newVal == null || newVal.isActive == false) {
        this.$router.push({ name: "networking" });
      }
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/event/Network.vue